<template>
  <template v-if="allImages.length === 1">
    <div class="flex-center overflow-hidden rounded-2xl">
      <ResponsiveImage
        :image="allImages[0]!"
        :alt="product.title"
        loading="eager"
        :class="allImages[0] === zoomImage && 'animate-zoom'"
        :width="468"
      />
    </div>
  </template>
  <EmblaCarousel
    v-else
    aria-label="Banners"
    class="product-gallery"
    arrows
    pagination
    :options="{ loop: true }"
  >
    <div
      v-if="zoomImage"
      class="embla__slide overflow-hidden"
    >
      <ResponsiveImage
        :image="zoomImage"
        :alt="product.title"
        loading="eager"
        class="animate-zoom"
        :width="468"
      />
    </div>
    <div
      v-for="(image, index) in sliderImages"
      :key="index"
      class="embla__slide"
    >
      <ResponsiveImage
        :image="image"
        :alt="product.title"
        loading="lazy"
        :width="468"
      />
    </div>
  </EmblaCarousel>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { EmblaCarousel } from '@oatsovernight/storybook'
import type { GraphqlBundleProduct } from '@/types/bundle'
import type {  Image } from '@/types/shopify'
import ResponsiveImage from '@/components/shared/v2/responsive-image.vue'

const IGNORE_ALT_REGEX = /profile|hover|cart/i

const props = defineProps<{
  product: GraphqlBundleProduct
}>()

const { images, zoomImage, flavorForwardImage } = props.product

const sliderImages = computed(() => {
  return images
    .slice(1)
    .filter(image => (
      !IGNORE_ALT_REGEX.test(String(image.altText))
      && !zoomImage?.url?.includes(image.url)
      && !flavorForwardImage?.url?.includes(image.url)
    ))
})

const allImages = computed(() => {
  const imgs: Image[] = []
  if (zoomImage) imgs.push(zoomImage)
  imgs.push(...sliderImages.value)
  return imgs
})
</script>
